import React, { useState } from 'react';
import { Loader2, RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';

const day = (iso) => (iso ? new Date(iso).toLocaleDateString('en-GB') : '—');

// Pairings an admin has dismissed as not duplicates. They are kept out of the
// findings list entirely — this is only the way back, in case a dismissal was
// made in error.
export default function EbayDismissedFindings({ dismissals, busy, onRestore }) {
  const [open, setOpen] = useState(false);
  if (!dismissals?.length) return null;

  return (
    <div className="mt-6 border-t border-white/10 pt-4">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="text-[10px] font-bold tracking-widest text-white/40 hover:text-white/70 transition-colors"
      >
        {dismissals.length} DISMISSED AS NOT DUPLICATES — {open ? 'HIDE' : 'SHOW'}
      </button>

      {open && (
        <div className="space-y-2 mt-3">
          {dismissals.map((d) => (
            <div
              key={d.id}
              className="border border-white/10 p-3 flex items-center gap-3 flex-wrap"
            >
              <div className="flex-1 min-w-0">
                <div className="text-white/70 text-sm">{d.summary || 'Dismissed pairing'}</div>
                <div className="text-[11px] text-white/40">
                  Dismissed {day(d.dismissed_at)}
                  {d.dismissed_by ? ` by ${d.dismissed_by}` : ''}
                </div>
              </div>
              <Button
                size="sm"
                variant="outline"
                className="bg-transparent border-white/15 text-white/70 hover:bg-white/5"
                disabled={busy === `${d.id}undismiss`}
                onClick={() => onRestore(d.id)}
              >
                {busy === `${d.id}undismiss` ? (
                  <Loader2 className="w-3.5 h-3.5 animate-spin" />
                ) : (
                  <RotateCcw className="w-3.5 h-3.5" />
                )}
                Restore
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}